"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dump = exports.Ph = exports.reporter = void 0;

var _react = _interopRequireDefault(require("react"));

var _contrast = _interopRequireDefault(require("contrast"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var reporter = function reporter() {
  var isDev = process.env.NODE_ENV == 'development';
  var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined;
  return {
    log: function log() {
      var _window$console;

      return isDev && isClient && (_window$console = window.console).log.apply(_window$console, arguments);
    },
    info: function info() {
      var _window$console2;

      return isDev && isClient && (_window$console2 = window.console).info.apply(_window$console2, arguments);
    },
    table: function table() {
      var _window$console3;

      return isDev && isClient && (_window$console3 = window.console).table.apply(_window$console3, arguments);
    },
    warn: function warn() {
      var _window$console4;

      return isDev && isClient && (_window$console4 = window.console).warn.apply(_window$console4, arguments);
    },
    error: function error() {
      var _window$console5;

      return isDev && isClient && (_window$console5 = window.console).error.apply(_window$console5, arguments);
    }
  };
};

exports.reporter = reporter;
var outerStyle = {
  position: 'relative',
  display: 'block'
};
var innerStyle = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
var textStyle = {
  fontSize: '14px',
  fontFamily: 'inherit',
  textAlign: 'center'
};

var Ph = function Ph(_ref) {
  var children = _ref.children,
      bg = _ref.bg,
      h = _ref.h,
      w = _ref.w,
      aspect = _ref.aspect,
      style = _ref.style,
      restProps = _objectWithoutProperties(_ref, ["children", "bg", "h", "w", "aspect", "style"]);

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    style: _objectSpread({
      width: "".concat(w ? "".concat(w, "px") : "".concat(100, "%"))
    }, style)
  }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
    style: _objectSpread(_objectSpread({}, outerStyle), {}, _defineProperty({
      color: "".concat(bg && (0, _contrast["default"])(bg) == 'dark' ? 'white' : 'black'),
      backgroundColor: "".concat(bg || 'rgba(0,0,0,0.1)')
    }, h ? 'height' : 'paddingBottom', "".concat(h ? "".concat(h, "px") : "".concat(100 / (aspect || 1), "%"))))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: innerStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: textStyle
  }, children))));
};

exports.Ph = Ph;

var Dump = function Dump(props) {
  return /*#__PURE__*/_react["default"].createElement("pre", null, /*#__PURE__*/_react["default"].createElement("code", null, JSON.stringify(props, null, 2)));
};

exports.Dump = Dump;